import { LogLevel, Configuration, RedirectRequest } from '@azure/msal-browser';

/**
 * Production Environment Configuration
 * Azure AD Corporate Authentication only (for Microsoft employees/managers)
 */

// Azure AD Corporate Configuration - for Microsoft employees
const aadTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47'; // Microsoft corporate tenant

// Azure AD Corporate MSAL Configuration for Microsoft employees
export const msalConfigCorporate: Configuration = {
    auth: {
        clientId: 'f9d80ff5-ac53-4f74-be20-55582788c3eb',
        authority: `https://login.microsoftonline.com/${aadTenantId}`,
        redirectUri: 'https://onboardinghub.microsoft.com/',
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

// Corporate scopes for Microsoft employees
const corporateScopes = [
    'api://f9d80ff5-ac53-4f74-be20-55582788c3eb/default'
];

// Function to get login request
export const getLoginRequest = (): RedirectRequest => {
    return { scopes: corporateScopes };
};

export const loginRequest: RedirectRequest = {
    scopes: corporateScopes,
};

// Production-specific settings
export const apiConfig = {
    baseUrl: 'https://newhirehub.microsoft.com',
    timeout: 30000,
};

export const appConfig = {
    enableDebugMode: false,
    enableAnalytics: true,
    logLevel: LogLevel.Error,
    applicationInsightsConnectionString:
        'InstrumentationKey=8f7245d3-141b-495c-b87c-d41145bc6058;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=1b9a5cb1-2e41-4254-a0cf-994b5db51c23',
};
